import React, { useState } from 'react';
import Cropper from 'react-easy-crop';
import getCroppedImg from './cropImageHelper'; // Helper function to crop

const CropImage = ({ aspectRatio, targetWidth, targetHeight, onImageCropped }) => {
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const handleFileChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];

      // Validate file type
      if (!['image/jpeg', 'image/png'].includes(file.type)) {
        alert('Only JPG and PNG files are allowed.');
        return;
      }

      const imageDataUrl = await readFile(file);
      setImageSrc(imageDataUrl);
    }
  };

  const handleCropDone = async () => {
    try {
      const { croppedBlob, croppedUrl } = await getCroppedImg(
        imageSrc,
        croppedAreaPixels,
        targetWidth,
        targetHeight
      );
      const croppedFile = new File([croppedBlob], "cropped_image.png", { type: "image/png" });
      onImageCropped(croppedFile, croppedUrl);
      setImageSrc(null); // Close Crop UI after cropping
    } catch (e) {
      console.error(e);
    }
  };

  const zoomIn = () => {
    setZoom((prevZoom) => Math.min(prevZoom + 0.1, 3)); // Maximum zoom 3x
  };

  const zoomOut = () => {
    setZoom((prevZoom) => Math.max(prevZoom - 0.1, 0.5)); // Minimum zoom 1x
  };

  return (
    <div>
     {imageSrc ? (
  <>
    <div style={{
      position: 'relative',
      width: '100%',
      height: '400px',
      background: '#333', // shows background for clarity
      overflow: 'hidden'  // contains crop area
    }}>
      <Cropper
        image={imageSrc}
        crop={crop}
        zoom={zoom}
        aspect={aspectRatio}
        onCropChange={setCrop}
        onZoomChange={setZoom}
        onCropComplete={onCropComplete}
      />
    </div>

    <div style={{ marginTop: 10, display: 'flex', alignItems: 'center', gap: '10px' }}>
      <button type="button" onClick={zoomOut}>-</button>
      <span>Zoom: {zoom.toFixed(1)}x</span>
      <button type="button" onClick={zoomIn}>+</button>
    </div>

    <div style={{ marginTop: 10 }}>
      <button onClick={handleCropDone}>Crop</button>
    </div>
  </>
) : (
  <input type="file" accept=".jpg,.jpeg,.png" onChange={handleFileChange} />
)}

    </div>
  );
};

function readFile(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => resolve(reader.result));
    reader.readAsDataURL(file);
  });
}

export default CropImage;
